import React, { useState, useEffect } from 'react';
import * as Icon from 'react-feather';
import { apiRepository } from '../../../../api/apiRepository';
import BaseModal from './baseModalDelete';
import { getErrorMessage } from '../../../../core/utils/errorUtils';
import { ValidationError } from '../../../../core/form/validationForm';
import { DeleteCouponsModalProps } from '../../../../core/Interface/modalInterface';

const DeleteCouponsModal: React.FC<DeleteCouponsModalProps> = ({ selectedPackageId, onDeleteSuccess }) => {
    const [show, setShow] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<ValidationError[]>([]);

    useEffect(() => {
        if (selectedPackageId) {
            setShow(true);
        }
    }, [selectedPackageId]);

    const getModalTitle = () => {
        if (!selectedPackageId?.type) return "Eliminar Producto";
        return selectedPackageId.type.toLowerCase().includes('membresia')
            ? "Eliminar Membresía"
            : "Eliminar Paquete";
    };

    const handleClose = () => {
        setShow(false);
        setErrors([]);
    };

    const handleConfirmDelete = async () => {
        if (!selectedPackageId?.id) return;

        try {
            setLoading(true);
            await apiRepository.deletePackage(selectedPackageId.id);
            setShow(false);
            onDeleteSuccess?.();
        } catch (error) {
            setErrors([{ field: "server", message: "Error al eliminar el elemento." }]);
            console.error("Error al eliminar:", error);
        } finally {
            setLoading(false);
        }
    };

    const getConfirmationMessage = () => {
        if (!selectedPackageId?.type) return "¿Estás seguro de que quieres eliminar este producto?";
        return selectedPackageId.type.toLowerCase().includes('membresia')
            ? "¿Estás seguro de que quieres eliminar esta membresía?"
            : "¿Estás seguro de que quieres eliminar este paquete?";
    };

    return (
        <BaseModal
            show={show}
            title={getModalTitle()}
            onClose={handleClose}
            onConfirm={handleConfirmDelete}
            loading={loading}
        >
            <div className="text-center">
                <Icon.Trash2 size={45} color='#f05050' className="text-danger fs-1" />
                <div className="mt-4">
                    <h4>{getModalTitle()}</h4>
                    <p className="text-muted mb-0">{getConfirmationMessage()}</p>
                    {errors.find(error => error.field === 'server') && (
                        <div className="alert alert-danger mt-3" role="alert">
                            {getErrorMessage(errors, "server")}
                        </div>
                    )}
                </div>
            </div>
        </BaseModal>
    );
};

export default DeleteCouponsModal;